import {Injectable, Inject} from '@angular/core';
import {Observable} from 'rxjs';
import {SoundcloudChannel, SoundCloudApiSearchResult} from "../../modele/social-media/soundcloudModels";
import {HttpHeaders, HttpClient, HttpResponse} from '@angular/common/http';
import {NGXLogger} from "ngx-logger";

//https://www.flickr.com/services/rest/?method=flickr.photos.getInfo&api_key=0497db51df740a1a985d5f23cc8e2cf9&photo_id=28934134284&format=json&nojsoncallback=1&auth_token=72157717864234498-5c68bdc7ead38ee9&api_sig=a6bf84acc3e894add00bab1df61951bc


export const FLICKR_API = 'https://www.flickr.com/services/rest/?method=';
export const FLICKR_API_KEY = '08f32e3cd2aece7d677254ad86e9d186';
export const FLICKR_AUTH_KEY = '72157717864234498-5c68bdc7ead38ee9';

@Injectable({
  providedIn: 'root'
})
export class FlickrService {
    log_prefix = this.constructor.name + ":";
    FLICKR_API_KEY = '08f32e3cd2aece7d677254ad86e9d186';

  constructor(
      private http: HttpClient,
      @Inject(FLICKR_API) private apiUrl: string,
      @Inject(FLICKR_API_KEY) private apiKey: string,
      @Inject(FLICKR_AUTH_KEY) private apiAuth: string,
      private logger: NGXLogger

  ) { }


   searchUserID(query: string): Observable <any[] > {
       let lp = this.log_prefix + "search:";
       const params = `${this.apiUrl}flickr.people.findByUsername&api_key=${this.apiKey}&username=${query}&format=json&nojsoncallback=1`;
       const queryUrl = `${this.apiUrl}${params}`;
       return new Observable<any[]>((observer) => {
           this.http.get(params).subscribe(resp => {
               let data = resp['user'];
               observer.next(data);
           });
       });
   }

   getUserInfo(query: string): Observable <any[] > {
       let lp = this.log_prefix + "search:";
       const params = `${this.apiUrl}flickr.people.getInfo&api_key=${this.apiKey}&user_id=${query}&format=json&nojsoncallback=1`;
       const queryUrl = `${this.apiUrl}api_key=${this.apiKey}${params}`;
       return new Observable<any[]>((observer) => {
           // let list : VimeoChannel[] = [];
           this.http.get(params).subscribe(resp => {
               let data = resp['person'];
               observer.next(data);
           });
       });
   }
   getUserPictures(query: string): Observable <any[] > {
       let lp = this.log_prefix + "search:";
       const params = `${this.apiUrl}flickr.people.getPhotos&api_key=${this.apiKey}&user_id=${query}&format=json&nojsoncallback=1&per_page=15`;
       const queryUrl = `${this.apiUrl}api_key=${this.apiKey}${params}`;
       return new Observable<any[]>((observer) => {
           // let list : VimeoChannel[] = [];
           this.http.get(params).subscribe(resp => {
               let data = resp['photos'];
               observer.next(data);
           });
       });
   }
   getUserPicturesSizes(query: string): Observable <any[] > {
       let lp = this.log_prefix + "search:";
       const params = `${this.apiUrl}flickr.photos.getSizes&api_key=${this.apiKey}&photo_id=${query}&format=json&nojsoncallback=1`;
       const queryUrl = `${this.apiUrl}api_key=${this.apiKey}${params}`;
       return new Observable<any[]>((observer) => {
           // let list : VimeoChannel[] = [];
           this.http.get(params).subscribe(resp => {
               let data = resp['sizes'];
               observer.next(data);
           });
       });
   }
   getUserPicturesInfo(query: string): Observable <any[] > {
       let lp = this.log_prefix + "search:";
       const params = `${this.apiUrl}flickr.photos.getInfo&api_key=${this.apiKey}&photo_id=${query}&format=json&nojsoncallback=1`;
       const queryUrl = `${this.apiUrl}api_key=${this.apiKey}${params}`;
       return new Observable<any[]>((observer) => {
           // let list : VimeoChannel[] = [];
           this.http.get(params).subscribe(resp => {
               let data = resp['photo'];
               observer.next(data);
           });
       });
   }



}
